import React, { Fragment, useContext, useRef, useState } from 'react';

// contexts
import { UserContext } from "../../Contexts/UserContext/UserContext.js";
import SwapBotContext from '../../Contexts/SwapBotContext.js';
import TxStateContext from '../../Contexts/TxStateContext.js';
import RuncraftContext from "../../Contexts/RuncraftContext.js"
// hooks
import useTxSender from '../../hooks/useTxSender.js';
// components
import { Row } from "../../components/Row";
import { Spaces } from "../../components/Spaces";
import { TextDisplay } from "../../components/TextDisplay/TextDisplay";
import { Tableau } from "../../components/Tableau";
import SuccessTxSender from '../../components/SuccessTxSender.js';
// other
import { getLogArray, forceInt, callWithNamedArgs, forceFloat } from "../../helpers/helpers.js"
import { default_func_jsx_fail, scrollRefIntoView } from '../../helpers/helpers.js';

import { DarkBlueButton } from "../app_launch/restore_wallet_from_file.js"
import { TextField } from '@mui/material';

import RunContext from "../../Contexts/RunContext.js"


// TODO find how to make this even more generic by allowing to call contract's functions that
// 		take more than just 1 field
function SlideUpdateContractGeneric(props) {
	// TODO turn currentVal, inputType, to arrays for functions with multiple params
	/**
	 * props:
	 * 		- title,					string, title of what to update, for display
	 *		- currentVal,				anything, current value of the field to update, for display (if null will display loader)
	 *		- (optional) placeholder 	string
	 *		- history_values			array of values, null to display loader
	 *		- inputType 				nothing for text, "int", "float" for 2 decimals, "str" to trim() spaces, "tokkenr:" for address (also accepts legacy "delphe:")
	 *		- Contract					the Contract to update
	 *	 	- update_func				str, the func name to call
	 *		- (optional) specific_state	{} a specific state to retrieve data after tx is sent
	 *		- (optional) callback		what to refresh after the tx has been sent
	 - 		- (optional) transformf		function to transform user input before passing it to function
	 */
	const [
		function_id,
		// log
	] = getLogArray("Slide_UpdateContractGeneric(): ")
	const classname = function_id

	const userContext = useContext(UserContext)
	const [newVal, set_newVal] = useState(null)
	const [textFieldError, set_textFieldError] = useState(null)

	// if slide changed, reset input
	const [last_title, set_last_title] = useState(null)
	if (last_title !== props.title) {
		set_newVal("") // reset input
		set_last_title(props.title)
		set_textFieldError(null) // also reset error
	}

	const runContext = useContext(RunContext)
	const run = runContext.run

	// log("props=",props)

	const tokenActionID = "swapbotContract_update_" + props.title.replace(' ', '_')

	const txStateContext = useContext(TxStateContext)

	async function update_contract() {
		const [function_id, log] = getLogArray(classname + "update_contract():")

		var transformed_newval = newVal
		if (props.transformf && newVal) {
			try {
				transformed_newval = await props.transformf(newVal)
			} catch (e) {
				console.error(function_id, "failed transformf for newVal=", newVal, "with error:", e)
			}
		}

		var result = await callWithNamedArgs(userContext.update_contract_generic, this, {
			tokenActionID: tokenActionID,
			Contract: props.Contract,
			update_func: props.update_func,
			func_params: [transformed_newval],
			callback: props.callback || null,
			specific_state: props.specific_state || { newVal: newVal },
			/* all args available:
				tokenActionID, confirmMess=null, confirmAction=null,
				Contract, update_func, func_params,
				callback=null, specific_state={}
			*/
		})
		log(tokenActionID, " result=", result)
	}

	const ref_messageEndRef = useRef(null) // for autoscroll
	const array_bool_user_inputs = [Boolean(newVal)]
	const bool_context_has_loaded = Boolean(props.currentVal != null)
	async function func_empty_fields() {
		set_newVal("") // reset input
	}

	const mess_default = "" //"Un récapitulatif des "+tokenName_plural+" à vendre va s'afficher ici"
	var jsx_loading = null //<LoaderWithMess mess={mess_default} />
	var jsx_recap = null
	// jsx_recap: we add each field one by one
	if (newVal != null) {
		jsx_recap = <Fragment>
			Mise à jour de {props.title} à la valeur {newVal}
		</Fragment>
	}
	const func_jsx_sending = <Fragment>
		Envoi de la mise à jour en cours...&nbsp;
		<i className="reloadIcon fas fa-sync fa-spin" />
	</Fragment>

	const func_jsx_success = (txstate) => {
		return (
			<SuccessTxSender txstate={txstate}>
				Mise à jour effectuée avec succès à la valeur {txstate.newVal}
			</SuccessTxSender>
		)
	}

	const func_onSuccess_once = () => {
		props.callback()
	}

	let [
		bool_broadcast_lock,
		func_resetMess,
		dict_update_button_style,
		jsx_mess,
	]
		= useTxSender(
			tokenActionID,
			array_bool_user_inputs,
			bool_context_has_loaded,
			ref_messageEndRef,
			mess_default,
			jsx_loading,
			jsx_recap,
			func_jsx_sending,
			func_jsx_success,
			default_func_jsx_fail,
			func_empty_fields,
			func_onSuccess_once,
		)

	async function handleChange(event) {
		let _newval = event.target.value

		// don't allow edit during sending
		if (bool_broadcast_lock) {
			window.alert("Echec: une demande est déjà en cours d'envoi.")
			return
		}

		if (txStateContext.broadcast_lock) return

		set_textFieldError(null)

		func_resetMess()

		// it makes sense to validate most cases here directly
		// even if we could ask the caller to provide a validation function (see 'else' below)
		if (props.inputType === "int") {
			_newval = forceInt(_newval)
			if (Number.isNaN(_newval)) _newval = ""
		}
		else if (props.inputType === "float") {
			_newval = forceFloat(_newval, 2)
		}
		else if (props.inputType === "str") {
			_newval = _newval.trim()  // remove spaces
		}
		// for now this works with copy/pastes at least
		else if (props.inputType === "tokkenr:") {
			_newval = _newval.trim()  // remove spaces
			// tokkenr: address: remove prefix; also accept legacy "delphe:" prefix
			if (_newval.toLowerCase().startsWith("tokkenr:")) {
				_newval = _newval.split("tokkenr:")[1]
			} else if (_newval.toLowerCase().startsWith("delphe:")) {
				_newval = _newval.split("delphe:")[1]
			} else {
				set_textFieldError("Erreur: Valeur non valide. inputType=" + String(props.inputType))
				_newval = ""
			}
		}
		else if (props.inputType === "run_txid") {
			_newval = _newval.trim()  // remove spaces
			if (_newval.length < 10 || !_newval.includes('_')) {
				set_textFieldError("Erreur: l'id de transaction doit contenir '_', got " + _newval
					+ " with inputType=" + String(props.inputType))
				_newval = ""
			}
			// try to load with run to validate
			run.trust(_newval.split('_')[0])
			let myJigClass = await run.load(_newval)
			if (!myJigClass.prototype.send) {
				set_textFieldError("Erreur: no send() function found for origin " + String(myJigClass.origin)
					+ " for " + _newval + " with inputType=" + String(props.inputType))
				_newval = ""
			}

		}
		// if we don't recognize the inputType we don't want to allow updating
		// this is where we might enforce the caller to provide his own validation function
		// for all cases that are not already handled
		else {
			set_textFieldError("inputType inconnu: " + String(props.inputType))
			_newval = ""
		}

		set_newVal(_newval)
	}

	// beware for currentVal: 0 is a valid value!
	if ((!props.currentVal && props.currentVal !== 0) || !newVal) {
		dict_update_button_style = {
			pointerEvents: "none",
			backgroundColor: "grey", // TODO move "grey" to more blue-ish #6e737b everywhere ??
		}
	}

	const history_title = <span>
		<i className="fas fa-history"></i><Spaces count="3" />
		Historique
	</span>

	let history_values2 = props.history_values
	// use currentVal!=null because 0 is a valid value!
	if (props.currentVal != null) {
		history_values2 = [props.currentVal + " (valeur actuelle)"].concat(history_values2)
	}

	const history_loading = (props.history_values == null || props.currentVal == null)

	return (
		<div style={{
			backgroundColor: "#33393d",
			padding: "20px",
			borderRadius: "0.7em",
		}}>
			<h1><i className="fas fa-edit" /><Spaces count="3" />
				Mise à jour: {props.title}
			</h1><br />

			<Row>
				<TextField fullWidth
					id="outlined-basic" variant="outlined"
					label={<span>Nouvelle valeur de {props.title}</span>}
					value={newVal ? newVal : ""}
					onChange={handleChange}
					placeholder={props.placeholder || ""}
					error={Boolean(textFieldError)}
					helperText={textFieldError}
				/>
			</Row><br />

			<center>
				<div ref={ref_messageEndRef}>
					{/* note: seems like the ref only works if it's NOT in some conditional rendering */}
					{jsx_mess ?
						<Row><TextDisplay>
							{jsx_mess}
						</TextDisplay></Row>
						: null}
				</div>
			</center>

			<Row>
				<button onClick={update_contract} style={dict_update_button_style} className="submitbutton" >
					Mettre à jour {props.title} {newVal ? "à " + newVal : null}
				</button>
			</Row>

			{/* TODO not urgent: add timestamp column from run's cache time://... */}
			<br /><br />
			<Tableau
				titles={[history_title]}
				values={history_values2}
				loading={history_loading}
				empty_mess="Aucune mise-à-jour pour le moment."
			/>

		</div>
	)
}


export function Slide_SwapBot_Contrat(props) {
	const [
		function_id,
		// log
	] = getLogArray("Slide_SwapBot_Contrat(): ")
	// const classname = function_id

	// swapbotContext
	const swapbotContext = useContext(SwapBotContext)
	const nbAvailableTokens = swapbotContext.nb_available_tokens
	const base_price = swapbotContext.base_price
	const secondary_price = swapbotContext.secondary_price
	const nbAvailableTokens_history = swapbotContext.history_nb_available_tokens

	const runContext = useContext(RunContext)
	const run = runContext.run

	// history_values
	const runcraftContext = useContext(RuncraftContext)
	const Runcraft = runcraftContext.Runcraft
	const TokenBuyRequest_Admin = Runcraft ? Runcraft.TokenBuyRequest_Admin : null
	const TokenSellRequest_Admin = Runcraft ? Runcraft.TokenSellRequest_Admin : null

	// we need to check for existence of these vars otherwise we will get a black screen
	// with "[error] TypeError: Cannot read property 'owner' of null"
	// TODO to handle that better, add a try/except around all of the below code ?
	// or find a way to handle it better in Slide_UpdateContractGeneric ?
	var history_token_sell_price_EUR = []
	// var receiving_address = null
	var TokenBuyRequest_Admin_owner = null,
		buy_admin_valid_token_origin = null
	if (TokenBuyRequest_Admin) {
		// receiving_address = TokenBuyRequest_Admin.receiving_address
		TokenBuyRequest_Admin_owner = TokenBuyRequest_Admin.owner
		if (TokenBuyRequest_Admin.valid_token_class) {
			buy_admin_valid_token_origin = TokenBuyRequest_Admin.valid_token_class.origin
		}
	}

	var TokenSellRequest_Admin_owner = null,
		TokenSellRequest_Admin_token_sell_price_EUR = null,
		sell_admin_valid_token_origin = null
	if (TokenSellRequest_Admin) {
		TokenSellRequest_Admin_owner = TokenSellRequest_Admin.owner
		TokenSellRequest_Admin_token_sell_price_EUR = TokenSellRequest_Admin.token_sell_price_EUR
		if (TokenSellRequest_Admin.history_token_sell_price_EUR) {
			history_token_sell_price_EUR = TokenSellRequest_Admin.history_token_sell_price_EUR
		}
		if (TokenSellRequest_Admin.valid_token_class) {
			sell_admin_valid_token_origin = TokenSellRequest_Admin.valid_token_class.origin
		}
	}

	// log("\n nbAvailableTokens=",nbAvailableTokens,
	// 	"\n nbAvailableTokens_history=",nbAvailableTokens_history)

	const run_txid_to_jig_class = async (run_txid) => {
		try {
			run.trust(run_txid.split('_')[0])
			let jigClass = await run.load(run_txid)
			// may need trustRecursive ?
			await jigClass.sync()
			return jigClass
		} catch (e) {
			console.error(function_id, "Error in transformf for update_valid_token_class"
				, "with run_txid=", run_txid, ": ", e)
		}
	}

	const available_actions = {
		"achats: tokens disponibles":
			<SlideUpdateContractGeneric
				title="tokens disponibles"
				inputType="int"
				placeholder="100"
				currentVal={nbAvailableTokens}
				history_values={nbAvailableTokens_history}
				Contract={TokenBuyRequest_Admin}
				update_func="update_available_tokens"
				callback={() => {
					swapbotContext.refresh_nbAvailableTokens()
					swapbotContext.refresh_history_AvailableTokensContract()
				}}
			/>,
		// shouldn't be needed for delphe but why not
		"achats: prix de base":
			<SlideUpdateContractGeneric
				title="prix de base"
				inputType="float"
				placeholder="1.00"
				currentVal={base_price}
				history_values={[]}
				Contract={TokenBuyRequest_Admin}
				update_func="update_token_base_price_EUR"
				callback={() => {
					swapbotContext.refresh_prices()
				}}
			/>,
		"achats: prix secondaire":
			<SlideUpdateContractGeneric
				title="prix secondaire"
				inputType="float"
				placeholder="1.25"
				currentVal={secondary_price}
				history_values={[]}
				Contract={TokenBuyRequest_Admin}
				update_func="update_token_secondary_price_EUR"
				callback={() => {
					swapbotContext.refresh_prices()
				}}
			/>,
		//  how to handle second param ? static changeOwner(newOwner, updateReceivingAddress=true){
"achats: propriétaire du contrat & adresse de réception des demandes (séparation possible plus tard)":
		<SlideUpdateContractGeneric
			title="achats: propriétaire du contrat & adresse de réception des demandes (séparation possible plus tard)"
			inputType="tokkenr:"
			placeholder="tokkenr:..."
			currentVal={TokenBuyRequest_Admin_owner}
			history_values={[]}
			Contract={TokenBuyRequest_Admin}
			update_func="changeOwner"
			callback={() => { }}
		/>,
	// "achats: adresse de réception des demandes":  // not the same as owner !
	// 	<Slide_UpdateContractGeneric
	// 		title="achats: adresse de réception des demandes d'achat"
	// 		inputType="tokkenr:"
	// 		placeholder="tokkenr:..."
	// 		currentVal={receiving_address}
	// 		history_values={[]}
	// 		Contract={TokenBuyRequest_Admin}
	// 		update_func="update_receiving_address"
	// 		callback={()=>{	}}
	// 	/>,
		// "prix de rachat" = TokenSellRequest_Admin.token_sell_price_EUR
		"ventes: prix de rachat":
			<SlideUpdateContractGeneric
				title="ventes: prix de rachat"
				inputType="float"
				placeholder="1.00"
				currentVal={TokenSellRequest_Admin_token_sell_price_EUR}
				history_values={history_token_sell_price_EUR}
				Contract={TokenSellRequest_Admin}
				update_func="update_token_sell_price_EUR"
				callback={() => {
					swapbotContext.refresh_prices()
				}}
			/>,
		//  how to handle second param ? static changeOwner(newOwner, updateReceivingAddress=true){
"ventes: propriétaire du contrat & adresse de réception des demandes (séparation possible plus tard)":
		<SlideUpdateContractGeneric
			title="ventes: propriétaire du contrat & adresse de réception des demandes (séparation possible plus tard)"
			inputType="tokkenr:"
			placeholder="tokkenr:..."
			currentVal={TokenSellRequest_Admin_owner}
			history_values={[]}
			Contract={TokenSellRequest_Admin}
			update_func="changeOwner"
			callback={() => { }}
		/>,

		"Achats: origine du contrat de tokens des demandes":
			<SlideUpdateContractGeneric
				title="achats: origine du contrat de tokens des demandes"
				inputType="run_txid"
				placeholder="id de transaction d'un contrat de token"
				currentVal={buy_admin_valid_token_origin}
				history_values={[]}
				Contract={TokenBuyRequest_Admin}
				update_func="update_valid_token_class"
				callback={() => { }}
				transformf={run_txid_to_jig_class}
			/>,
		"Ventes: origine du contrat de tokens des demandes":
			<SlideUpdateContractGeneric
				title="ventes: origine du contrat de tokens des demandes"
				inputType="run_txid"
				placeholder="id de transaction d'un contrat de token"
				currentVal={sell_admin_valid_token_origin}
				history_values={[]}
				Contract={TokenSellRequest_Admin}
				update_func="update_valid_token_class"
				callback={() => { }}
				transformf={run_txid_to_jig_class}
			/>,

	}

	const [displayActionSlide, set_displayActionSlide] = useState(null)

	const ref_up = useRef(null)

	var jsx_available_actions = null
	Object.keys(available_actions).forEach(curr_action => {
		jsx_available_actions = <Fragment>
			{jsx_available_actions}
			<div>
				<DarkBlueButton variant="dark" style={{
					cursor: "pointer", padding: "0.8em", width: "80%", marginLeft: "10%"
				}}
					// dont set the jsx here or it will not be update, so we only set the name
					onClick={() => {
						set_displayActionSlide(curr_action)
						scrollRefIntoView(ref_up)
					}}
				>
					{curr_action}<br />
				</DarkBlueButton>
			</div>
		</Fragment>
	})
	jsx_available_actions = <div style={{}}>{jsx_available_actions}</div>

	let jsx_actionSlide = null
	if (displayActionSlide && available_actions[displayActionSlide]) {
		jsx_actionSlide = available_actions[displayActionSlide]
	}

	return (
		<div>
			<div ref={ref_up} />

			{jsx_actionSlide ? <Fragment>
				{jsx_actionSlide}<br /><br />
			</Fragment> : null}

			<h1><i className="fas fa-robot" /><Spaces count="3" />
				Contrat SwapBot
			</h1><br /><br />

			<center><h4>
				Que voulez vous mettre à jour ou consulter ?
			</h4></center><br />

			{jsx_available_actions}

		</div>
	)
}
